import {
  holdsWordSlot,
  KIT_WORD_SLOT,
  type QuizKitCopy,
} from '@peach/types/quizzes/generated-quiz.dto.js';

export function kitDoor(username: string): string {
  return `meetmy.io/${username}`;
}

/** The last slide's line (`QuizKitCopy`), plus the word it asks for. */
export type KitCopy = QuizKitCopy & { word: string };

/**
 * What a quiz without a kit says — hand-written ones, and every quiz before
 * 2026-09-13. English whatever the quiz's language: those were not worth a backfill.
 */
export const STOCK_KIT_COPY: QuizKitCopy = {
  door: `Comment ${KIT_WORD_SLOT} to get the flashcards and test yourself`,
};

/**
 * The last slide before 2026-10-01, for a creator with no Instagram connected: a comment
 * would get no answer, so it sends readers to the link in bio. `word` is the marked part.
 */
export const LINK_IN_BIO_COPY: KitCopy = {
  door: `Take the full quiz and see your score\n${KIT_WORD_SLOT}`,
  word: 'Link in bio',
};

/**
 * The generator's line when the quiz has one, else the stock line. A stored door with
 * no word slot (every kit written before 2026-10-01 says "Link in bio") takes the stock
 * door, in English where the quiz's own line can't. No word (no Instagram connected)
 * takes the link-in-bio slide.
 */
export function kitCopyOf(kit: QuizKitCopy | undefined, word: string | null): KitCopy {
  if (word === null) return LINK_IN_BIO_COPY;
  const door = kit && holdsWordSlot(kit.door) ? kit.door : STOCK_KIT_COPY.door;
  return { door, word };
}
